import React, { useState } from 'react'
import { TOGGLE_OPEN_TO_WORK } from '../../Utils/apis';
import { useDispatch } from 'react-redux';
import { updateOpenToWork } from '../../Store/Slices/user';

const useChangeOpenToWork = () => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fn = async (status) => {

        if (!loading) {
            try {
                setLoading(true)
                const res = await fetch(TOGGLE_OPEN_TO_WORK, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({open_to_work: status}),
                });

                if (res.ok) {
                    const jobs = await res.json();
                    dispatch(updateOpenToWork(status));

                }
                else {
                    const err = await res.json();
                    throw new Error(err.error);
                }
            } catch (error) {
                setError(error.message);
                return Promise.reject(error.message);
            }
            finally {
                setLoading(false);
            }
        }
    }

    return [loading, error, fn];
}

export default useChangeOpenToWork;